// extracted by mini-css-extract-plugin
export var dataCell = "_r9-2";
export var dataRow = "_r9-0";
export var headerRow = "_r9-1";